import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { LazyLoadEvent, SelectItem } from 'primeng/primeng';
import moment from 'moment';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admin-addons-list',
  templateUrl: './admin-addons-list.component.html',
  styleUrls: ['./admin-addons-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class AdminAddonsListComponent implements OnInit {

  clientNameDD = [];
  clientNameOptions: SelectItem[];
  projectTypeOptions: SelectItem[];
  projectStatusOptions: SelectItem[];
  projectStatusOptionsTab2: SelectItem[];
  typeOfProjectOptions: SelectItem[];
  totalRecords: number;
  loading: boolean;
  loadEventData: LazyLoadEvent;
  selectProjectType: String[];
  selectProjectStatus: String[];
  selectClientName: String[];
  selectProjectTypeCompleted: String[];
  selectProjectStatusCompleted: String[];
  selectClientNameCompleted: String[];
  projects: any[] = [];
  projectDetails: any[] = [];
  selectedProject: any = { name: '', id: '' };
  myControl = new FormControl();
  filteredOptions: Observable<any[]>;
  cols: any[];
  projectOnGoingList = [];
  projectCompletedList = [];
  projectGrid = [];
  projectOnGoingGrid = [];
  projectCompletedGrid = [];
  value: any;
  userId = this.parseService.instance.User.current().id;
  empRole = '';
  showFilter: any;
  gridView: boolean;
  todayDate = new Date();
  projectMems = [];
  today = new Date().toISOString();
  tabIndex: number;
  tabGirdIndex: any;
  projectType: string;
  typeOfProject: String[];
  typeOfProject1: String[];
  customRoles = [];
  projectsList: string;
  profileId: any;
  totalgridRecords: number;
  tenantId: any;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private toastr: ToastrService,
  ) {
    this.projectTypeOptions = [
      // { label: 'Dedicated', value: 'Dedicated' },
      // { label: 'Fixed', value: 'Fixed' }
      { label: 'Fixed Billable', value: 'Fixed Billable'},
      { label: 'Fixed Non-Billable', value: 'Fixed Non-Billable'},
      { label: 'Time and Material Billable', value: 'Time and Material Billable'},
      { label: 'Time and Material Non-Billable', value: 'Time and Material Non-Billable'},
    ];

    this.typeOfProjectOptions = [
      { label: 'Project', value: 'Project' },
      { label: 'Sub-Project', value: 'Sub-Project' }
    ];

    this.projectStatusOptions = [
      { label: 'New', value: 'New' },
      { label: 'In Progress', value: 'In Progress' }
    ];

    this.projectStatusOptionsTab2 = [
      { label: 'On Hold', value: 'On Hold' },
      { label: 'Completed', value: 'Completed' },
      { label: 'Rejected', value: 'Rejected' },
    ]

    this.cols = [
      { header: 'S.No', field: 'position' },
      { field: 'action', header: 'Action' },
      { header: 'Project Name', field: 'projectName' },
      // { header: 'Platform', field: 'projectPlatform' },
      // { header: 'Start Date', field: 'projectStartDate' },
      // { header: 'Due Date', field: 'projectEndDate' },
      { header: 'Project Type', field: 'typeOfProject' },
      { header: 'Client Name', field: 'clientName' },
      { header: 'Billing Type', field: 'projectType' },
      { header: 'Project Status', field: 'currentStatus' }
    ];
  }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  async ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    await query.find().then(res => {
      if (res.length > 0) {
        let roleDetail = res[0];
        this.customRoles = roleDetail.get('customRoles');
        let employeesdata = this.customRoles[1];
        var keys = Object.keys(employeesdata);
        var filtered = keys.filter(function (key) {
          if (typeof employeesdata[key] != 'string') {
            return employeesdata[key]
          }
        });
        this.projectsList = filtered[0];
      }
    });

    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tabChange(0);
    this.tabGridChange(0);
    this.getClientName();
    this.gridView = false;
    this.getProMembers();
    this.getProjectDropdown();

    let filter = JSON.parse(localStorage.getItem('projectsOnGoingTable'));
    if (filter != null && filter.filters != undefined) {
      if (filter.filters[this.projectsList != 'All' ? 'projectType' : 'projectInfo.projectType'] != undefined) {
        this.selectProjectType = filter.filters[this.projectsList != 'All' ? 'projectType' : 'projectInfo.projectType'].value;
      }
      if (filter.filters[this.projectsList != 'All' ? 'currentStatus' : 'projectInfo.currentStatus'] != undefined) {
        this.selectProjectStatus = filter.filters[this.projectsList != 'All' ? 'currentStatus' : 'projectInfo.currentStatus'].value;
      }
      if (filter.filters[this.projectsList != 'All' ? 'clientName' : 'client'] != undefined) {
        this.selectClientName = filter.filters[this.projectsList != 'All' ? 'clientName' : 'client'].value;
      }
    }

  }

  getProMembers() {
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('user');
    query.include('user.profile');
    query.equalTo('tenantId', this.tenantId);
    query.limit(500000);
    query.find().then(result => {
      this.projectMems = result;
      this.getProjects();
    });
  }

  /*
  ** ==========================================================
  ** Bind dropdown values
  ** ==========================================================
  */
  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a, value: a });
    });
    return dropDownItem;
  }

  bindClientDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      if (this.projectsList == 'All') {
        dropDownItem.push({ label: a.name, value: a.id });
      } else {
        dropDownItem.push({ label: a.name, value: a.name });
      }
    });
    return dropDownItem;
  }

  async getClientName() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Client', [{ condition: 'equalTo' }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId},
    { field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let clientNameInfo = JSON.parse(jsonText);
        result.push({ name: clientNameInfo.companyInfo.firstName.concat(' ' + clientNameInfo.companyInfo.lastName), id: clientNameInfo.objectId });
      }
      this.clientNameDD = result;
      this.clientNameDD = this.clientNameDD.sort((a, b) => a.name.localeCompare(b.name));
      this.clientNameOptions = this.bindClientDropDown(this.clientNameDD);
    });
  }

  /*
  ** ==========================================================
  ** Get Projects
  ** ==========================================================
  */
  async getProjects() {
    if (this.projectsList == 'Assigned') {
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
        [
          { condition: 'equalTo', field: 'status', value: 'Assigned' },
          { condition: 'include', value: 'project' },
          { condition: 'include', value: 'project.client' },
          { condition: 'include', value: 'user' },
          { condition: 'limit', value: 10000 },
          { condition: 'equalTo', field: 'user', value: { __type: 'Pointer', className: '_User', objectId: this.userId } },
          { condition: 'equalTo', field: 'projectType', value: 'Sub-Project' }
        ]).then(results => {
          this.employeeProjects(results);
        });
    }

    else if (this.projectsList == 'All') {
      let type = ['New', 'In Progress'];
      let condn = 'containedIn';
      this.queryInterface.executeQuery(this.parseService, 'Project',
        [
          { condition: 'include', value: 'client' },
          { condition: 'limit', value: 1000 },
          { condition: 'equalTo', field: 'projectType', value: 'Project' },
          { condition: 'descending', field: 'updatedAt' },
          { condition: 'equalTo', field: 'isActive', value: true },
          { condition: condn, field: 'projectInfo.currentStatus', value: type },
          { condition: 'equalTo', field: 'tenantId', value: this.tenantId}
        ]).then(results => {
          this.projectGrid = this.loadResourcesAdmin(results, 0);
          this.projectGrid = this.projectGrid.sort((a, b) => a.projectType.localeCompare(b.projectType));
          this.totalgridRecords = this.projectGrid.length;
          this.clientNameDD = this.clientNameDD.sort((a, b) => a.name.localeCompare(b.name));
          this.clientNameOptions = this.bindClientDropDown(this.clientNameDD);
        });
    }
  }

  employeeProjects(results) {
    let projects = [];
    let list = [];
    let grid = [];
    results.forEach(element => {
      projects.push(element.get('project'));
    });
    projects.forEach(element => {
      let status = element.get('projectInfo').currentStatus;
      if (status == 'New' || status == 'In Progress') {
        list.push(element);
      }
    });
    this.projectOnGoingList = this.loadResourcesAdmin(list, 0);
    projects.forEach(element => {
      let status = element.get('projectInfo').currentStatus;
      if (status == 'New' || status == 'In Progress') {
        grid.push(element);
      }
    });
    this.projectGrid = this.loadResourcesAdmin(grid, 0);
  }

  /*
  ** ==========================================================
  ** Get Project Details
  ** ==========================================================
  */
  loadResourcesLeader(results, skip) {
    let result = [];
    let i = skip;
    let projectDetails = results.filter(x => x.get('project').get('projectType') == 'Project');
    projectDetails.forEach(element => {
      let resourceDetails = element.get('project').get('resourceDetails').details;
      let totalhours = this.getHoursCount(resourceDetails);
      let totalResource = this.getResourceCount(resourceDetails);

      i = i + 1;
      let project = element.get('project');
      let projectdetail = project.get('projectInfo');
      let client = project.get('client');
      let clientdetail = client.get('companyInfo');
      let typeOfProject = project.get('projectType');
      let progress = this.getProgressPercent(
        projectdetail.projectStartDate,
        projectdetail.actualCompletionDate
      );
      result.push({
        position: i,
        projectName: projectdetail.projectName,
        currentStatus: projectdetail.currentStatus,
        projectStartDate: projectdetail.projectStartDate,
        projectEndDate: projectdetail.actualCompletionDate,
        clientName: clientdetail.firstName.concat(' ' + clientdetail.lastName),
        projectType: projectdetail.projectType,
        projectPlatform: projectdetail.projectPlatform,
        progress: progress,
        objectId: project.id,
        totalhours: totalhours,
        totalcount: totalResource,
        resourceDetails: resourceDetails,
        projectMembers: this.getProjectMembersName(project),
        typeOfProject: typeOfProject
      });
    });
    return result;
  }

  getDifference(startDate, endDate) {
    const daydiff = moment(startDate).diff(moment(endDate), 'days');
    return Math.abs(daydiff);
  }

  getProgressPercent(start, end) {
    if (new Date() > new Date(start)) {
      let totalDiff = this.getDifference(start, end);
      let currentDiff = this.getDifference(start, new Date());
      return (currentDiff / totalDiff) * 100;
    } else {
      return 0;
    }
  }

  /*
  ** ==========================================================
  ** Get Project Members
  ** ==========================================================
  */
  getProjectMembers(project) {
    let proMembers = [];
    let memName = [];
    proMembers = this.projectMems.filter(s => s.get('project').id == project.id);
    proMembers.forEach(element => {
      let fName = element.get('user').get('profile').get('firstName');
      let lName = element.get('user').get('profile').get('lastName');
      let name = fName + ' ' + lName;
      let shortName = fName.charAt(0).toUpperCase() + lName.charAt(0).toUpperCase();
      memName.push({ name: name, shortName: shortName });
    });
    return memName;
  }

  getProjectMembersName(project) {
    let proMembers = [];
    let proMembersAssigned = [];
    let profileImageInfo = [];
    proMembers = this.projectMems.filter(s => s.get('project').id == project.id);
    proMembersAssigned = proMembers.filter(a => a.get('status') == 'Assigned');
    proMembersAssigned.forEach(res => {
      let profilePic = res.get('user').get('profile').get('profileImageInfo').url;
      let fName = res.get('user').get('profile').get('firstName');
      let lName = res.get('user').get('profile').get('lastName');
      let name = fName + ' ' + lName;
      let shortName = fName.charAt(0).toUpperCase() + lName.charAt(0).toUpperCase();
      profileImageInfo.push({ name: name, shortName: shortName, profilePic: profilePic });
    });
    return profileImageInfo;
  }

  /*
  ** ==========================================================
  ** Get Project Details
  ** ==========================================================
  */
  loadResourcesAdmin(results, skip) {
    let result = [];
    let i = skip;
    results.forEach(element => {
      i = i + 1;
      let total = element.get('resourceDetails').details;
      let totalResource = this.getResourceCount(total);
      let totalhours = this.getHoursCount(total);
      let typeOfProject = element.get('projectType');
      let projectdetail = element.get('projectInfo');
      let client = element.get('client');
      let clientdetail = client.get('companyInfo');
      let progress = this.getProgressPercent(
        projectdetail.projectStartDate,
        projectdetail.actualCompletionDate
      );
      result.push({
        position: i,
        projectName: projectdetail.projectName,
        currentStatus: projectdetail.currentStatus,
        projectStartDate: projectdetail.projectStartDate,
        projectEndDate: projectdetail.actualCompletionDate,
        clientName: clientdetail.firstName.concat(' ' + clientdetail.lastName),
        projectType: projectdetail.projectType,
        projectPlatform: projectdetail.projectPlatform,
        progress: progress,
        objectId: element.id,
        totalhours: totalhours,
        totalcount: totalResource,
        projectMembers: this.getProjectMembersName(element),
        typeOfProject: typeOfProject
      });
    });
    return result;
  }

  getHoursCount(totalhours) {
    let total = 0;
    totalhours.forEach(element => {
      total += element.hours;
    });
    return total;
  }


  getResourceCount(totalcount) {
    let total = 0;
    totalcount.forEach(element => {
      total += element.count;
    });
    return total;
  }

  /*
  ** ==========================================================
  ** Lazy load
  ** ==========================================================
  */
  async onLazyLoad(event: LazyLoadEvent, status) {
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    query.equalTo('tenantId', this.tenantId);
    await query.find().then(res => {
      let roleDetail = res[0];
      this.customRoles = roleDetail.get('customRoles');
      let employeesdata = this.customRoles[1];
      var keys = Object.keys(employeesdata);
      var filtered = keys.filter(function (key) {
        if (typeof employeesdata[key] != 'string') {
          return employeesdata[key]
        }
      });
      this.projectsList = filtered[0];
    });

    this.loadEventData = event;
    let condition = [];
    let type = '';
    let statusType = ['In Progress', 'New'];
    if (this.projectsList == 'Assigned') {
      condition = [
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' },
        { condition: 'equalTo', field: 'user', value: { __type: 'Pointer', className: '_User', objectId: this.userId } },
        { condition: 'equalTo', field: 'projectType', value: 'Sub-Project' },
      ];
      type = 'ProjectMembers';
    } else if (this.projectsList == 'All') {
      let condn = status == 'completed' ? 'notContainedIn' : 'containedIn';
      condition = [
        { condition: 'include', value: 'client' },
        { condition: 'equalTo', field: 'projectType', value: 'Project' },
        { condition: 'descending', field: 'updatedAt' },
        { condition: 'equalTo', field: 'isActive', value: true },
        { condition: condn, field: 'projectInfo.currentStatus', value: statusType },
        { condition: 'equalTo', field: 'projectType', value: 'Sub-Project' },
      ];
      type = 'Project';
    }

    const filter: any = event.filters;
    if (!filter) {
      const skip: number = event.first;
      this.totalRecords = await this.getTotalRecordsCount(condition, type);
      this.lazyLoad(condition, skip, type, event.rows, status);
    } else if (event.sortField) {
      const skip: number = event.first;

      let field = event.sortField;
      let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let query = filter[key].value;
        if (key == 'projectInfo.projectType' || key == 'client' || key == 'projectInfo.currentStatus') {
          condition.push({
            condition: 'containedIn',
            field: key,
            value: filter[key].value
          });
        } else {
          let filterValue;
          filterValue = filter[key].value.replace(/\b\w/g, l =>
            l.toUpperCase()
          );
          condition.push({
            condition: 'contains',
            field: key,
            value: filterValue
          });
        }
      }
      if (sortOrder == 'ascending') {
        condition.push({ condition: sortOrder, value: field });
      } else {
        condition.push({ condition: sortOrder, field: field });
      }

      this.totalRecords = await this.getTotalRecordsCount(condition, type);
      if (this.totalRecords < event.first) {
        event.first = 0;
      }
      this.lazyLoad(condition, skip, type, event.rows, status);
    } else {
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let query = filter[key].value;
        if (key == 'projectInfo.projectType' || key == 'client' || key == 'projectInfo.currentStatus') {
          condition.push({
            condition: 'containedIn',
            field: key,
            value: filter[key].value
          });
        } else {
          let filterValue;
          filterValue = filter[key].value.replace(/\b\w/g, l =>
            l.toUpperCase()
          );
          condition.push({
            condition: 'contains',
            field: key,
            value: filterValue
          });
        }
      }
      this.totalRecords = await this.getTotalRecordsCount(condition, type);
      if (this.totalRecords < event.first) {
        event.first = 0;
      }
      this.lazyLoad(condition, event.first, type, event.rows, status);
    }
  }

  lazyLoad(condition, skip, type, limit, status) {
    condition.push(
      { condition: 'skip', value: skip },
      { condition: 'limit', value: limit }
    );
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      if (this.projectsList == 'All') {
        let list = this.loadResourcesAdmin(results, skip);
        status == 'completed' ? this.projectCompletedList = list : this.projectOnGoingList = list;
      } else {
        let list = this.loadResourcesLeader(results, skip);
        status == 'completed' ? this.projectCompletedList = list : this.projectOnGoingList = list;
      }
    }).catch(error => {
      return [];
    });
  }

  getTotalRecordsCount(condition, type) {
    return this.getQueryCount(this.parseService, type, condition);
  }

  /*
  ** ==========================================================
  ** Get total records
  ** ==========================================================
  */
  getCount() {
    let id = '';
    let condition = [];
    let type = '';
    if (this.projectsList == 'Assigned') {
      id = this.userId;
      type = 'ProjectMembers';
      condition.push(
        { condition: 'equalTo', field: 'user', value: { __type: 'Pointer', className: '_User', objectId: id } },
        { condition: 'include', value: 'client' },
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' },
        { condition: 'equalTo', field: 'projectType', value: 'Sub-Project' },
      );
    } else if (this.projectsList == 'All') {
      type = 'Project';
      condition.push(
        { condition: 'include', value: 'client' },
        { condition: 'equalTo', field: 'projectType', value: 'Sub-Project' },
        { condition: 'descending', field: 'updatedAt' },
        { condition: 'equalTo', field: 'isActive', value: true }
      );
    }
    return this.getQueryCount(this.parseService, type, condition);
  }

  getQueryCount(parseService, type, condition) {
    return this.queryInterface.getQueryCount(parseService, type, condition);
  }

  /*
  ** ==========================================================
  ** Update Project Information
  ** ==========================================================
  */
  async updateProjectInformation(events) {
    let queryInstance = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', events);
    query.equalTo('tenantId', this.tenantId);
    await query.find().then(results => {
      let result = results[0]
      this.projectType = result.get('projectType');
    });
    this.router.navigate(['project-detail', { id: events, projectType: this.projectType }]);
  }

  /*
  ** ==========================================================
  ** Go to sprint
  ** ==========================================================
  */
  async goToBacklogs(projectId, projectName) {
    let result = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    await query.find().then(results => {
      result = results;
      if (result.length > 0) {
        this.router.navigate(['/scrumboard/board/analytics/' + projectId + '/' + projectName]);
      }
      else {
        this.toastr.warning('Please create backlog board');
      }
    });
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  toogleView(val) {
    this.gridView = val;
    this.getProjects();
  }

  tabChange(index): void {
    this.tabIndex = index;
    this.getProjects();
  }

  tabGridChange(index): void {
    this.tabGirdIndex = index;
    this.getProjects();
  }

  /*
  ** ==========================================================
  ** Get projects dropdown
  ** ==========================================================
  */
  getProjectDropdown(): void {
    let condition = [];
    let type = '';
    condition = [
      { field: 'objectId', condition: 'descending' },
      { condition: 'include', value: 'client' },
      { condition: 'limit', value: 10000 },
      { condition: 'equalTo', field: 'projectType', value: 'Sub-Project' },
      { condition: 'containedIn', field: 'projectInfo.currentStatus', value: ['New', 'In Progress', 'Completed'] },
    ];
    type = 'Project';
    this.projectList(type, condition);
  }

  projectList(type, condition): void {
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      this.projects = [];
      this.projectDetails = [];
      results.forEach(element => {
        this.projects.push({ id: element.id, name: element.get('projectInfo').projectName });
        this.projectDetails.push({ id: element.id, name: element.get('projectInfo').projectName, projectInfo: element.get('projectInfo') });
      });
      this.projects = this.projects.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
      this.selectedProject = this.projects[0];
      this.tabChange(0);
      this.tabGridChange(0);
      this.getFilteredValue();
    });
  }

  getFilteredValue() {
    if (this.projects.length > 0) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(skillSets => this._filter(skillSets))
      );
    }
  }

  private _filter(value: string): any[] {
    let projects = JSON.stringify(this.projects);
    let projectList = JSON.parse(projects);
    const filterValue = value.toLowerCase();
    return projectList.filter(option => option.name
      .toString()
      .toLowerCase()
      .includes(filterValue)
    );
  }

  onFilter(event, dt): any {
    this.totalRecords = dt._totalRecords;
  }


}

